const ua = navigator.userAgent;

export const isIE = /*@cc_on!@*/false || !!document.documentMode;
export const isEdge = Boolean(!isIE && window.StyleMedia);
export const isChrome = Boolean(window.chrome && window.chrome.webstore);
export const isFirefox = typeof InstallTrigger !== 'undefined';
export const isSafari = /constructor/i.test(window.HTMLElement) || (window.safari && safari.pushNotification && safari.pushNotification.toString()) === '[object SafariRemoteNotification]';

export const isIPad = /iPad/i.test(ua);
export const isIPhone = /iPhone/i.test(ua);
export const isAndroid = /Android/i.test(ua);

export const isMobile = Boolean(window.is_mobile_site || window.is_mobile || isIPhone || isAndroid);
export const isDesktop = !isMobile;

const evite = window.evite = window.evite || {};
const detects = evite.detects = window.evite.detects || {};

Object.assign(detects, exports);

export default detects;



// WEBPACK FOOTER //
// ./assets/es6/common/evite/detects.es6